export default __webpack_public_path__ + "static/media/down-arrow.af643293.svg";